import Vue from 'vue'
import VueI18n from 'vue-i18n'
Vue.use(VueI18n)
import zh from './zh'
import en from './en'
import hk from './hk'
import it from './it'
import de from './de'
import fra from './fra'
import pt from './portugal'
let locale = window.localStorage.getItem('locale') || '';
if(locale == ''){
  locale = 'en';
 localStorage.setItem('locale',locale);
 localStorage.setItem('lang',locale);
}
export default new VueI18n({
  locale:locale,
  messages:{
    en,
    pt,
    zh,
    hk,
    it,
    de,
    fra
  }
})
